module.exports = __webpack_public_path__ + "static/img/mcs_logo.fd638ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lp/mcs_logo.jpg
// module id = YR0Y
// module chunks = 0